import { render, staticRenderFns } from "./BaseStreamVideo.vue?vue&type=template&id=8f9cb280&scoped=true&"
import script from "./BaseStreamVideo.vue?vue&type=script&lang=ts&"
export * from "./BaseStreamVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStreamVideo.vue?vue&type=style&index=0&id=8f9cb280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9cb280",
  null
  
)

export default component.exports